import { Component, Host, h, Prop } from '@stencil/core';
import { checkLanguageCookie } from '../../utils/utils';

@Component({
  tag: 'article-share-block',
  styleUrl: 'article-share-block.css',
  shadow: false,
})
export class ArticleShareBlock {
  /**
   * shareBlock
   */
  @Prop() shareBlock: string;
  /**
   * Image alt
   */
  @Prop() imageAlt: string;
  /**
   * Asset Type
   */
  @Prop() assetType: string;
  /**
   * Video
   */
  @Prop() videoUrl: string;
  /**
   * Caption
   */
  @Prop() caption: string;
  /**
   * Share Post
   */
  @Prop() sharePost: string;
  /**
   * stay Connected
   */
  @Prop() stayConnected: string;

  /**
   * subscribe Today
   */
  @Prop() subscribeToday: string;

  /**
   * Background Color
   */
  @Prop() backgroundColor: string;

  /**
   * Text Color
   */
  @Prop() textColor: string;

  /**
   * Padding Top
   */
  @Prop() paddingTop: string;

  /**
   * Padding Bottom
   */
  @Prop() paddingBottom: string;

  /**
   * Background Image Url
   */
  @Prop() backgroundImage: string;
  render() {
    //const shareBlock = JSON.parse(this.shareBlock);
    //console.log(shareBlock);

    // Get the language code from the cookie
    const langCode = checkLanguageCookie('wp-wpml_current_language'); 
    // Construct the href dynamically
    const href = langCode ? `/${langCode}/preference-center` : '/preference-center';
    return (
      <Host>
        <div
          class={`article-container share-block-wrapper flex justify-between flex-col sm:flex-row mx-auto gap-32px ${this.backgroundColor} ${this.paddingBottom} ${this.paddingTop} pt-medium`}
        >
          <div class={`mx-auto`}>
            <h3 class={`fs-2 text-ui-gray-1 mb-12px font-semibold text-center`}>{this.sharePost}</h3>
            <slot></slot>
          </div>
          <div class={`w-fit mx-auto`}>
            <h3 class={`fs-2 text-ui-gray-1 mb-12px font-semibold text-center`}>{this.stayConnected}</h3>
            <a href={href} target={`_blank`} class={`article-share-btn mx-auto`}>
              {this.subscribeToday}
            </a>
          </div>
        </div>
      </Host>
    );
  }
}
